import { makeStyles } from "@material-ui/core";
import * as React from "react";
import { checkDeviceType } from "src/helpers";

const useStyles = makeStyles((theme: any) => ({
  input: {
    "&:focus": {
      borderColor: "#aaaaaa"
    },
    "&[readonly]": {
      color: "rgba(0,0,0,.3)"
    },
    fontFamily: "Open Sans, Helvetica, Arial, sans-serif",
    border: "1px solid #bdbdbd",
    borderRadius: 4,
    color: "#595959",
    fontSize: "1.6rem",
    height: "36px",
    lineHeight: "36px",
    padding: "0 15px",
    width: "100%"
  },
  mobileInput: {
    background: "none" as "none",
    border: "none" as "none",
    fontSize: "1.6rem",
    lineHeight: "1.6rem",
    width: "100%"
  },
  mobileLabel: {
    fontSize: "1rem"
  },
  mobileWrapper: {
    background: "#ffffff",
    border: "1px solid #bdbdbd",
    borderRadius: 4,
    color: "#545454",
    display: "block" as "block",
    padding: "6px 12px",
    [theme.breakpoints.up("md")]: {
      display: "none" as "none"
    }
  }
}));

interface IOwnProps {
  name?: string;
  placeholder?: string;
  onChange?: (e: any) => void;
  value?: string;
  defaultValue?: string;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  dataTestId?: string;
}

const TextInputLongText = ({ placeholder, ...otherProps }: IOwnProps) => {
  const inputRef = React.useRef<HTMLTextAreaElement>(null);
  const classes = useStyles();

  // give inital height to textarea
  React.useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
  }, []);
  const handleMobileClick = React.useCallback(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef.current]);
  const deviceType = checkDeviceType();

  // arrange textare height on text input change
  const handleKeyDown = (e: any) => {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  return (
    <>
      {deviceType === "mobile" ? (
        <div onClick={handleMobileClick} className={classes.mobileWrapper}>
          <div className={classes.mobileLabel}>
            <span>{placeholder}</span>
          </div>
          <textarea
            ref={inputRef}
            placeholder={placeholder}
            className={classes.mobileInput}
            onInput={handleKeyDown}
            {...otherProps}
          />
        </div>
      ) : (
        <div>
          <textarea
            ref={inputRef}
            placeholder={placeholder}
            className={classes.input}
            onInput={handleKeyDown}
            {...otherProps}
          />
        </div>
      )}
    </>
  );
};

export default React.memo(TextInputLongText);
